/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

const menuclassName = "py-3";

const FieldExecutiveSideMenu = () => {
  return (
    <aside id="left-panel" className="h-100">
      <nav>
        <ul className="pt-3">
          <li className={menuclassName}>
            <Link to={"#"}>
              <i className="fa fa-lg fa-fw fa-home"></i>{" "}
              <span className="menu-item-parent">Dashboard</span>
            </Link>
          </li>
          <li className={menuclassName}>
            <Link to={"/field-executive/my-account"}>
              <i className="fa fa-lg fa-fw fa-user-circle"></i>{" "}
              <span className="menu-item-parent">My Account</span>
            </Link>
          </li>
        </ul>
      </nav>
      {/* <span className="minifyme" data-action="minifyMenu">
        <i className="fa fa-arrow-circle-left hit"></i>
      </span> */}
    </aside>
  );
};

export default FieldExecutiveSideMenu;
